/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation readBroadcastMutation($id: ID!) {
        readBroadcast(id: $id)
    }
`;
